module.exports = __webpack_public_path__ + "static/media/icon-weibo-white-selected.58ed6803.svg";